<template>
  <div class="kontakt-container">
    <div class="kontakt-details">
      <div class="kontakt-header">
        <h1>Kontakt</h1>
        <p>
          Ihr könnt mich ganz unverbindlich per Mail, WhatsApp, Instagram oder auch telefonisch kontaktieren.
        </p>
        <p>
          Ihr seid noch unsicher? Wir können gerne ein kurzes Gespräch per Telefon oder Zoom vereinbaren, um uns kennenzulernen und herauszufinden, ob meine Beratung zu euch und eurem Problem passt.
        </p>
      </div>
      
      <div class="hero-image">
        <img src="@/assets/maike_kontakt.jpg" alt="Maike Röhrig – Familienbegleitung Koblenz" width="300" height="auto"/>
      </div>
    </div>
 
    <div class="kontakt-details">
      <div class="kontakt-info">
        <h2>Maikes Familienbegleitung</h2>
        <p>E-Mail: <a href="mailto:info@maikes-familienbegleitung.de" aria-label="E-Mail an Maikes Familienbegleitung" target="_blank" rel="noopener">info@maikes-familienbegleitung.de</a></p>
        <p>Telefon: <a href="tel:+4915773577671" aria-label="Maikes Familienbegleitung anrufen" target="_blank" rel="noopener">+49 1577 3577671</a></p>
        <p>WhatsApp: <a href="https://wa.me/4915773577671?text=Liebe%20Maike%2C%20ich%20habe%20eine%20Frage%20zu%20..." aria-label="WhatsApp Chat mit Maikes Familienbegleitung starten" target="_blank" rel="noopener">WhatsApp öffnen</a></p>
        <p>Instagram: <a href="https://www.instagram.com/maikes_familienbegleitung" aria-label="Maikes Familienbegleitung bei Instagram" target="_blank" rel="noopener">@maikes_familienbegleitung</a></p>
        <p>56072 Koblenz-Metternich</p>
        <KontaktButton />
      </div>
      
      <div class="kontakt-formular">
        <form @submit.prevent="submitForm">
          <label for="name">Name*</label>
          <input type="text" id="name" v-model="formData.name" required />          
          
          <label for="email">E-Mail*</label>
          <input type="email" id="email" v-model="formData.email" required />          
          
          <label for="telefon">Telefonnummer</label>
          <input type="tel" id="telefon" v-model="formData.telefonnummer" />
          
          <label for="thema">Thema*</label>
          <select id="thema" v-model="formData.thema" required>
            <option value="" disabled>Bitte wählen...</option>
            <option v-for="thema in themenAuswahl" :key="thema" :value="thema">
              {{ thema }}
            </option>
          </select>

          <!-- Dynamisches Feld für Wohnort bei Stillberatung -->
          <div v-if="formData.thema === 'Stillberatung'">
            <label for="wohnort">Wohnort*</label>
            <input 
              type="text" 
              id="wohnort" 
              v-model="formData.wohnort" 
              placeholder="für Anfahrtsplanung"
              :required="formData.thema === 'Stillberatung'" 
            />
            <p class="hinweis-text">Hinweis: Bei Stillberatungen – insbesondere in den ersten Lebenswochen – empfehle ich eine persönliche Beratung, um euch auch z.B. beim Anlegen und den Stillpositionen bestmöglich unterstützen zu können.</p>
          </div>
          
          <label for="nachricht">Nachricht*</label>
          <textarea id="nachricht" v-model="formData.nachricht" required></textarea>
          
          <div class="checkbox-container">
            <input type="checkbox" id="datenschutz" v-model="formData.datenschutz" required />
            <label for="datenschutz">Ich habe die Datenschutzerklärung zur Kenntnis genommen und erkläre mich hiermit einverstanden.*</label>
          </div>          
          
          <button class="cta-button" type="submit">Senden</button>
        </form>
      </div>
    </div>
    
  </div>
</template>
 
<script>
  import KontaktButton from '@/components/KontaktButton.vue';

  export default {
    name: 'Kontakt',
    components: {
      KontaktButton
    },
    data() {
        return {
            formData: {
                name: '',
                email: '',
                telefonnummer: '',
                thema: '', // Startet leer, damit der "Bitte wählen..." Placeholder greift
                wohnort: '',
                nachricht: '',
                datenschutz: false,
            },
            // HIER DIE THEMEN EINTRAGEN:
            themenAuswahl: [
                'Allgemeine Anfrage',
                'Stillberatung',
                'Abstillberatung',
                'Schlafberatung',
                'Beikostberatung',
                'Stillvorbereitung',
                'Schlafworkshop',
                'Beikostworkshop',
                'Papa-Krabbelgruppe',
                'Sonstiges'
            ]
        };
    },
    mounted() {
      // 1. Thema vorauswählen
      const queryTopic = this.$route.query.topic;
      if (queryTopic && this.themenAuswahl.includes(queryTopic)) {
        this.formData.thema = queryTopic;
      }
      // 2. Nachricht vorformulieren
      const queryMessage = this.$route.query.message;
      if (queryMessage) {
        this.formData.nachricht = queryMessage;
      }
    },
    methods: {
        async submitForm() {
            const url = "https://script.google.com/macros/s/AKfycbzW142tI9gAGDwZo3Vy8LO18IK5ma1fQDsTc8_sUoTg51MGqXp30dqkVfQV9JCwHaUgbw/exec";

            const payload = {
                name: this.formData.name,
                email: this.formData.email,
                telephone: this.formData.telefonnummer,
                topic: this.formData.thema,
                wohnort: this.formData.wohnort,
                message: this.formData.nachricht,
            };

            try {
              const controller = new AbortController();
              const timeoutId = setTimeout(() => controller.abort(), 15000); // 15s Timeout

              const response = await fetch(url, {
                  method: "POST",
                  body: JSON.stringify(payload),
                  signal: controller.signal
              });

              const result = await response.json();
              clearTimeout(timeoutId);

              if (result.status === "success") {
                alert('Formular erfolgreich gesendet!');

                // Reset des Formulars NUR bei Erfolg
                this.formData = {
                    name: '',
                    email: '',
                    telefonnummer: '',
                    thema: '',
                    wohnort: '',
                    nachricht: '',
                    datenschutz: false,
                };
              } else {
                  alert("Fehler beim Senden des Formulars.");
                  console.error("Fehler vom Server:", result.message);
              }

            } catch (error) {
                if (error.name === 'AbortError') {
                    alert('Zeitüberschreitung. Der Server antwortet nicht. Bitte versuche es später noch einmal.');
                } else {
                    console.error("Netzwerkfehler:", error);
                    alert("Netzwerkfehler. Bitte überprüfe deine Verbindung und versuche es später noch einmal.");
                }
            }
        }
    }
  }
</script>


<style>
/* Container & Layout */
.kontakt-container {
  padding: 1.25rem;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem; /* Nutzt gap statt margin-right für sauberere Abstände */
}

.kontakt-header {
  flex: 1 1 100%; /* Header nimmt oben die volle Breite ein */
  margin-bottom: 1rem;
}

.kontakt-details {
  flex: 1;
  min-width: 300px;
}

.kontakt-info {
  margin-bottom: 2rem;
}

.kontakt-formular {
  flex: 1.5; /* Formular etwas breiter als die Info-Spalte */
  min-width: 300px;
}

/* Formular-Elemente */
form {
  display: flex;
  flex-direction: column;
  gap: 1rem; /* Gleichmäßiger Abstand zwischen den Feldern */
}

label {
  font-weight: bold;
  margin-bottom: -0.5rem; /* Zieht Label näher an das Input-Feld */
}

input, 
textarea, 
select {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-family: inherit; /* Verhindert Schriftart-Wechsel bei Formularfeldern */
  font-size: 1rem;
  width: 100%;
  box-sizing: border-box; /* Wichtig, damit Padding die Breite nicht sprengt */
}

select {
  background-color: white;
  cursor: pointer;
  appearance: none; /* Entfernt teilweise Browser-Styling */
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 1rem;
}

textarea {
  min-height: 120px;
  resize: vertical; /* Erlaubt nur vertikales Vergrößern */
}

.checkbox-container {
  display: flex;
  align-items: flex-start; /* Aliniert Checkbox oben, falls Label mehrzeilig ist */
  gap: 10px;
  margin-top: 0.5rem;
}

.checkbox-container input[type="checkbox"] {
  width: auto;
  margin-top: 4px;
}

.checkbox-container label {
  font-weight: normal;
  font-size: 0.9rem;
  line-height: 1.4;
}

.hinweis-text {
  font-size: 0.8rem;
  color: var(--font-color-light);
  font-style: italic;
  margin-top: 0.2rem;
}

/* Responsive Anpassungen */
@media (max-width: 48rem) {
  .kontakt-container {
    flex-direction: column;
  }
  
  .kontakt-details, 
  .kontakt-formular {
    min-width: 100%;
  }
}
</style>